import { useState, lazy, Suspense } from 'react';
import close from './assets/close-white.svg';
import { isMobileWithTablet } from './utils';

const MapViewer = ({ closeCallback }) => {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        margin: 'auto',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 3,
      }}
    >
      <div
        style={{
          height: isMobileWithTablet ? '30vh' : '70vh',
        }}
      >
        <Suspense fallback={null}>
          <iframe
            src="https://www.google.com/maps/d/u/0/embed?mid=1d8ucjfX-M4e8Hq7uoV5htXiaaGNaXIby&z=5"
            width={isMobileWithTablet ? '320' : '640'}
            height={isMobileWithTablet ? '240' : '480'}
          ></iframe>
        </Suspense>
      </div>

      <div
        style={{
          position: 'absolute',
          bottom: isMobileWithTablet ? '18vh' : '5vh',
          right: 0,
          left: 0,
          margin: 'auto',
          width: '50px',
          borderRadius: '50px',
          backgroundColor: 'rgba(0,0,0,0.2)',
        }}
        onClick={() => closeCallback()}
      >
        <img src={close} style={{ width: '50px', cursor: 'pointer' }} />
      </div>
    </div>
  );
};

export default MapViewer;
